import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a1b19e48&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b19e48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1b19e48')) {
      api.createRecord('a1b19e48', component.options)
    } else {
      api.reload('a1b19e48', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a1b19e48&scoped=true", function () {
      api.rerender('a1b19e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxOfficialAdmin/index.vue"
export default component.exports